import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll handling on SPA navigation: jump to top on a new path, or to the
 * target element when the URL carries a hash (e.g. /careers#openings).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
